/**
 * Tiny dev-only logger. In production builds (NODE_ENV === "production")
 * these calls become no-ops, so client-side warnings never leak debug info
 * to the console of end users while still being available during dev.
 */
const isDev =
  typeof process !== "undefined" &&
  process.env &&
  process.env.NODE_ENV !== "production";

export const devWarn = (...args) => {
  if (isDev) {
    // eslint-disable-next-line no-console
    console.warn(...args);
  }
};

export const devError = (...args) => {
  if (isDev) {
    // eslint-disable-next-line no-console
    console.error(...args);
  }
};
